import React from 'react';

const Location = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#3d1778' }}>
      <h1 style={{ fontSize: '3rem', color: '#fff' }}>Coming Soon</h1>
    </div>
  );
};

export default Location;
